import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
  selector: 'app-unavailable-dates-config',
  templateUrl: './unavailable-dates-config.component.html',
  styleUrls: ['./unavailable-dates-config.component.scss'],
})
export class UnavailableDatesConfigComponent implements OnInit {
  @Input() data;
  @Input() vehicles;
  @Input() configuredSlots;
  @Output() close = new EventEmitter();
  public saving = false;
  public selectedVehicles: any = [];
  public minDate = new Date();
  public countryData: any = {};
  public weekDays = [0, 1, 2, 3, 4, 5, 6];
  public disabledDays : any = [];

  constructor(
    private collectionsService: CollectionsV2Service,
    private helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.countryData = this.helpersService.getCountryData();
    if (this.data.linkedVehicles) {
      this.selectedVehicles = this.data.linkedVehicles.map((x) => {
        return x.deliveryVehicleID.toString();
      });
    }
    this.updateDisabledDays();
  }

  valid() {
    return (
      this.data.date &&
      this.data.startTime &&
      this.data.endTime > 0 &&
      this.data.endTime > this.data.startTime &&
      this.selectedVehicles &&
      this.selectedVehicles.length > 0
    );
  }

  save() {
    this.saving = true;
    var request = JSON.parse(JSON.stringify(this.data));
    request.date = moment(this.data.date).format('YYYY-MM-DD');
    request.startTime = moment(this.data.startTime).format('HH:mm:ss');
    request.endTime = moment(this.data.endTime).format('HH:mm:ss');
    request.linkedVehicles = this.selectedVehicles.map((x) => {
      return { deliveryVehicleID: x };
    });

    if (request.id) {
      this.collectionsService.updateUnavailableDate(request).subscribe(
        (res) => {
          this.saving = false;
          this.close.emit('');
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.collectionsService
        .addUnavailableDate(this.helpersService.getPartnerId(), request)
        .subscribe(
          (res) => {
            this.saving = false;
            this.close.emit('');
          },
          (err) => {
            this.saving = false;
          },
        );
    }
  }

  updateDisabledDays() {
    var enabledDays = this.configuredSlots.map((x) => {
      return x.dayOfWeek;
    });

    var disabledDays = [];
    this.weekDays.forEach((day) => {
      if (enabledDays.indexOf(day) === -1) {
        disabledDays.push(day);
      }
    });
    this.disabledDays = disabledDays;
  }
}
